import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
import ToolsOverviewPage from "./pages/ToolsOverviewPage";
import HomePage from "./pages/HomePage";
import SplitPage from "./pages/SplitPage";
import MergePage from "./pages/MergePage";
import CompressPdfPage from "./pages/CompressPdfPage";
import LockUnlockPdfPage from "./pages/LockUnlockPdfPage";
import ImageToolsPage from "./pages/ImageToolsPage";
import ConvertImagePage from "./pages/ConvertImagePage";
import ResizeImagePage from "./pages/ResizeImagePage";
import CompressImagePage from "./pages/CompressImagePage";
import BackgroundRemoverPage from "./pages/BackgroundRemoverPage";
import NotepadPage from "./pages/NotepadPage";
import CaseConverterPage from "./pages/CaseConverterPage";
import FindAndReplacePage from "./pages/FindAndReplacePage";
import JsonBeautifierPage from "./pages/JsonBeautifierPage";
import PasswordGeneratorPage from "./pages/PasswordGeneratorPage";
import QrCodeGeneratorPage from "./pages/QrCodeGeneratorPage";
import AppScreenshotGeneratorPage from "./pages/AppScreenshotGeneratorPage";
import FeatureGraphicGeneratorPage from "./pages/FeatureGraphicGeneratorPage";
import NotFoundPage from "./pages/NotFoundPage";
import { PdfProvider } from "./context/PdfContext";
import { AuthProvider } from "./context/AuthContext";

function App() {
  return (
    <div className="App min-h-screen bg-gradient-to-br from-slate-50 to-gray-100">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <PdfProvider>
              <Navbar />
              <main className="container mx-auto px-4 py-8">
              <Routes>
              <Route path="/" element={<ToolsOverviewPage />} />
              <Route path="/pdf" element={<HomePage />} />
              {/* PDF Tools - Old and New URLs */}
              <Route path="/split" element={<SplitPage />} />
              <Route path="/split-pdf" element={<SplitPage />} />
              <Route path="/merge" element={<MergePage />} />
              <Route path="/merge-pdf" element={<MergePage />} />
              <Route path="/compress" element={<CompressPdfPage />} />
              <Route path="/compress-pdf" element={<CompressPdfPage />} />
              <Route path="/lock-unlock" element={<LockUnlockPdfPage />} />
              <Route path="/lock-unlock-pdf" element={<LockUnlockPdfPage />} />
              <Route path="/unlock" element={<LockUnlockPdfPage />} />
              {/* Image Tools */}
              <Route path="/images" element={<ImageToolsPage />} />
              <Route path="/convert-image" element={<ConvertImagePage />} />
              <Route path="/convert-to-jpg" element={<ConvertImagePage />} />
              <Route path="/convert-to-png" element={<ConvertImagePage />} />
              <Route path="/convert-to-webp" element={<ConvertImagePage />} />
              <Route path="/resize-image" element={<ResizeImagePage />} />
              <Route path="/compress-image" element={<CompressImagePage />} />
              <Route path="/remove-background" element={<BackgroundRemoverPage />} />
              {/* Text Tools - Old and New URLs */}
              <Route path="/notepad" element={<NotepadPage />} />
              <Route path="/online-notepad" element={<NotepadPage />} />
              <Route path="/case-converter" element={<CaseConverterPage />} />
              <Route path="/text-case-converter" element={<CaseConverterPage />} />
              <Route path="/find-replace" element={<FindAndReplacePage />} />
              <Route path="/text-find-replace" element={<FindAndReplacePage />} />
              {/* JSON Tools */}
              <Route path="/json-beautifier" element={<JsonBeautifierPage />} />
              {/* Utility Tools */}
              <Route path="/qr-code-generator" element={<QrCodeGeneratorPage />} />
              <Route path="/password-generator" element={<PasswordGeneratorPage />} />
              {/* Publishing Tools */}
              <Route path="/app-screenshot-generator" element={<AppScreenshotGeneratorPage />} />
              <Route path="/feature-graphic-generator" element={<FeatureGraphicGeneratorPage />} />
              {/* 404 Catch-all route - must be last */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
              </main>
              <Toaster />
            </PdfProvider>
          </AuthProvider>
      </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
